import { render, staticRenderFns } from "./ActPassBtn.vue?vue&type=template&id=9322baba"
import script from "./ActPassBtn.vue?vue&type=script&lang=js"
export * from "./ActPassBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports